var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLido(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 1080,
    viewBox: "0 0 1080 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M540 1080C838.234 1080 1080 838.234 1080 540C1080 241.766 838.234 0 540 0C241.766 0 0 241.766 0 540C0 838.234 241.766 1080 540 1080Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M318.491 501.636L312.445 510.91C244.258 615.511 259.486 752.502 349.059 840.266C401.754 891.898 470.817 917.717 539.882 917.724C539.882 917.724 539.882 917.724 318.491 501.636Z",
    fill: "#00A3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M539.818 628.095L318.428 501.636C539.819 917.724 539.818 917.724 539.818 917.724C539.818 827.103 539.818 723.263 539.818 628.095Z",
    fill: "#00A3FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M761.509 501.636L767.555 510.91C835.742 615.511 820.514 752.502 730.941 840.266C678.246 891.898 609.183 917.717 540.118 917.724C540.118 917.724 540.118 917.724 761.509 501.636Z",
    fill: "#00A3FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M540.094 628.095L761.484 501.636C540.095 917.724 540.094 917.724 540.094 917.724C540.094 827.103 540.094 723.263 540.094 628.095Z",
    fill: "#00A3FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M540.176 345.586V563.694L730.879 454.711L540.176 345.586Z",
    fill: "#00A3FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M540.119 345.586L349.277 454.708L540.119 563.694V345.586Z",
    fill: "#00A3FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M540.119 162.158L349.277 454.78L540.119 345.35V162.158Z",
    fill: "#00A3FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M540.176 345.317L731.025 454.749L540.176 161.982V345.317Z",
    fill: "#00A3FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLido);
export default __webpack_public_path__ + "static/media/lido.9e0cfa2cd1242040573797d879f6ddd7.svg";
export { ForwardRef as ReactComponent };